<!--
/*******************************************************************************
*@ 컴포넌트명   : TrsaccGroupAcnoTab.vue
*@ 컴포넌트설명 : 당행이체 - 입금계좌번호 (그룹선택)
*@ 사용전문     :  
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <div class="form">
      <div class="form-row">
        <div class="item-desc">
          <select-box
            ref="trsaccGroup"
            :value.sync="mgtSerno"
            :option-list="grpList"
            :hidden-default-text="true"
            label-i18n="MPAY-01-01-25-01"
            placeholder="MPAY-01-01-04-04"
            template="desc"
            @selected="selectedTrsaccGrp"
            :i18n-use="false"
          >
            <template #noData>
              <strong
                class="info-question nomargin-top"
              >{{ /*등록된 이체 그룹이 없습니다.*/ $t("MPAY-01-01-25-03") }}</strong>
            </template>
          </select-box>
        </div>
        <div class="inline-button-group">
          <button class="btn sm inline line" @click="onTrsaccGrpUpdate()">
            <i class="icon icon-modify" />
            {{ /*그룹 수정*/ $t("MPAY-01-01-04-05") }}
          </button>
          <button class="btn sm inline line" @click="onTrsaccGrpDelete()">
            <i class="icon icon-del-02" />
            {{ /*그룹 삭제*/ $t("MPAY-01-01-04-06") }}
          </button>
        </div>
      </div>
    </div>
    <ul class="form-check-group --type2">
      <li class="form-check-group-item" v-for="(item, i) in grpDtlList" :key="i">
        <div class="form-check">
          <input
            type="checkbox"
            :id="`checkbox${i}`"
            class="form-check-input"
            :value="item.regiSerno"
            v-model="checkedAcnoList"
            :disabled="item.disabled"
          />
          <label class="form-check-label" :for="`checkbox${i}`">
            <span class="name">{{ item.dpstrName }}</span>
            {{`${item.mgtAcno}(${item.cncycd})`}}
          </label>
        </div>
      </li>
    </ul>
    <modal-pop
      :opened.sync="openedDeletePopup"
      :modal-header="true"
      title="MPAY-01-01-24-09"
      :no-negative-button="true"
      confirm="MCOM-0000006"
      cancel="MCOM-0000005"
      @confirm="RBF0605S60Call()"
      @cancel="() => {openedDeletePopup = false}"
    >
      <template
        #content
      >{{ /*$1 그룹을 삭제하시겠습니까?*/ $t("MPAY-01-01-24-10", {1:$refs.trsaccGroup.selectedText}) }}</template>
    </modal-pop>
  </article>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapGetters, mapActions } from "vuex";
import { RBF0400A40 } from "@/mixins/transfer";

export default {
  mixins: [RBF0400A40],
  props: {
    listInit: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.initMgtSerno = this.$route.params.mgtSerno;

    if (this.$route.params.mgtSerno) {
      if (this.initMgtSerno < 0) this.initMgtSerno = 0;
      this.setTrsaccGrp();
    } else {
      this.initMgtSerno = 0;
      this.initGrpList();
    }
  },
  data() {
    return {
      initMgtSerno: 0,
      mgtSerno: "",
      grpList: [],
      grpDtlList: [],
      checkedAcnoList: [],
      page: "transfer",
      openedDeletePopup: false, //그룹삭제팝업
    };
  },
  computed: {
    ...mapFields(["sessionInfo", "siteCode"]),
    ...mapFields("transfer/trsaccInfoInpt", ["RBF0605S40", "trsaccGrpList", "trsaccGrpInfo"]),
    ...mapGetters("transfer/trsaccInfoInpt", ["getTrsaccDrwotInfo", "getTrsaccGrpListTemplate", "getTrsaccGrpDetailTemplate"]),
    currMgtSernoIdx: {
      get() {
        return this.trsaccGrpList.data.findIndex(item => {
          return item.mgtSerno == this.mgtSerno;
        });
      },
    },
  },
  methods: {
    ...mapActions("transfer/trsaccInfoInpt", ["ACT_setTrsaccGrpList_init"]),
    initGrpList() {
      this.ACT_setTrsaccGrpList_init();

      if (this.RBF0605S40.totalLineCnt > 0) {
        this.trsaccGrpList.trsaccGrpCnt = this.RBF0605S40.totalLineCnt;

        for (const data of this.RBF0605S40.dataGrid) {
          let info = {
            ...this.getTrsaccGrpListTemplate,
            mgtSerno: data.mgtSerno,
            trsaccGroupName: data.trsaccGroupName,
            regiYMS: data.regiYMS,
          };

          this.trsaccGrpList.data.push(info);
        }
      } else {
        this.trsaccGrpList = {};
      }

      this.setTrsaccGrp();
    },
    RBF0605S41Call() {
      this.$post("/transfer/trsaccgrp/TrsaccGrpDtlInq", { mgtSerno: this.mgtSerno }, this.RBF0605S41Suc, this.RBF0605S41Fail);
    },
    async RBF0605S41Suc(res) {
      let RBF0605S41 = res.outItem;

      if (RBF0605S41.totalLineCnt > 0) {
        let list = [];
        let list2 = [];

        this.trsaccGrpList.data[this.currMgtSernoIdx].detailCnt = RBF0605S41.totalLineCnt;

        for (const data of RBF0605S41.dataGrid) {
          const info = {
            ...this.getTrsaccGrpDetailTemplate,
            regiSerno: data.regiSerno, //등록일련번호
            dpstrName: data.dpstrName, //예금주명
            mgtAcno: data.mgtAcno, //관리계좌번호
            cncycd: data.cncycd, //통화코드
            drwotAcnMemoCtnt: data.drwotAcnMemoCtnt, //송금메모
            mnrcvAcnMemoCtnt: data.mnrcvAcnMemoCtnt, //수취인참고내용
            disabled: false,
          };
          list.push(info);
          list2.push({ acno: data.mgtAcno, cncycd: data.cncycd, acnoAls: "", regiSerno: data.regiSerno });
        }
        this.trsaccGrpList.data[this.currMgtSernoIdx].detail = list;

        list2 = await this.makeListMnrcv(list2);

        list.forEach(v => {
          if (
            list2.filter(item => {
              return item.text == v.mgtAcno + " (" + v.cncycd + ")";
            }).length < 1
          ) {
            v.disabled = true;
          }
        });

        this.grpDtlList = list;
      } else {
        this.grpDtlList = [];
      }
    },
    RBF0605S41Fail() {
      this.trsaccGrpList.data[this.currMgtSernoIdx].detailCnt = -1;
      this.trsaccGrpList.data[this.currMgtSernoIdx].detail = [];
      this.grpDtlList = [];
    },
    RBF0605S60Call() {
      if (!this.mgtSerno || this.currMgtSernoIdx < 0) return;

      let params = {
        inquryPrcssDstcd: "3", //처리구분코드 (1: 등록 2: 수정 3: 삭제)
        mgtSerno: this.mgtSerno, //관리일련번호
      };

      this.$post("/transfer/trsaccgrp/TrsaccGrpSave", params, this.RBF0605S60Suc);
    },
    RBF0605S60Suc() {
      this.trsaccGrpList.data.splice(this.currMgtSernoIdx, 1);
      this.trsaccGrpList.trsaccGrpCnt = this.trsaccGrpList.data.length;

      this.$refs.trsaccGroup.init();
      this.setTrsaccGrp();
    },
    onTrsaccGrpUpdate() {
      this.trsaccGrpInfo = this.getTrsaccGrpListTemplate;

      if (this.mgtSerno) {
        this.trsaccGrpInfo = this.trsaccGrpList.data[this.currMgtSernoIdx];
        this.$router.push({ name: "trsaccInfoInptReqGrpUpdat" });
      }
    },
    onTrsaccGrpDelete() {
      if (this.mgtSerno > 0) {
        this.openedDeletePopup = true;
      }
    },
    selectedTrsaccGrp() {
      if (this.currMgtSernoIdx > -1) {
        if (this.trsaccGrpList.data[this.currMgtSernoIdx].detailCnt > 0) {
          this.grpDtlList = this.trsaccGrpList.data[this.currMgtSernoIdx].detail;
        } else {
          if (this.trsaccGrpList.data[this.currMgtSernoIdx].detailCnt != -1) this.RBF0605S41Call();
        }
      } else {
        this.grpDtlList = [];
      }
    },
    setTrsaccGrp() {
      let info = [];

      if (this.trsaccGrpList.trsaccGrpCnt > 0) {
        this.trsaccGrpList.data.forEach(item => {
          info.push({ text: item.trsaccGroupName, value: item.mgtSerno, data: { date: this.$getGlobalDateYmd(item.regiYMS) } });
        });
      }

      this.grpList = info;
      this.$refs.trsaccGroup.setOptionList(this.grpList, false);

      if (this.initMgtSerno > 0) {
        this.$refs.trsaccGroup.setValue(this.initMgtSerno);
        this.mgtSerno = this.initMgtSerno;

        this.selectedTrsaccGrp();
      } else {
        this.grpDtlList = [];
      }
    },
    getTrsaccGrpInfo() {
      let info = [];

      for (const v of this.checkedAcnoList) {
        let fndIdx = this.trsaccGrpList.data[this.currMgtSernoIdx].detail.findIndex(item => {
          return item.regiSerno == v;
        });

        if (fndIdx > -1) {
          info.push({
            trsaccDstcd:
              this.sessionInfo.userInfo.baseCncycd == this.getTrsaccDrwotInfo.cncycd &&
              this.getTrsaccDrwotInfo.cncycd == this.trsaccGrpList.data[this.currMgtSernoIdx].detail[fndIdx].cncycd
                ? "01"
                : "02",
            acno: this.trsaccGrpList.data[this.currMgtSernoIdx].detail[fndIdx].mgtAcno,
            acnoAls: this.trsaccGrpList.data[this.currMgtSernoIdx].detail[fndIdx].dpstrName,
            cncycd: this.trsaccGrpList.data[this.currMgtSernoIdx].detail[fndIdx].cncycd,
            drwotRmark: this.trsaccGrpList.data[this.currMgtSernoIdx].detail[fndIdx].drwotAcnMemoCtnt,
            mnrcvRmark: this.trsaccGrpList.data[this.currMgtSernoIdx].detail[fndIdx].mnrcvAcnMemoCtnt,
          });
        }
      }

      return info;
    },
  },
};
</script>